export default "dist/images/block-button-basic.311cbc1.png";